import moment from "moment";
import { useTranslation } from "react-i18next";

const useDateFormat = () => {
    const { t, i18n } = useTranslation();

    const getDateFormatByLanguage = () => {
        const translation = t("madera.dateFormat");
        //If we cannot get the value we set the default for each language
        if (translation === "madera.dateFormat") {
            if (i18n.language.slice(0, 2) === "es") {
                return "DD/MM/YYYY";
            } else {
                return "MM/DD/YYYY";
            }
        }
        return translation;
    };

    const getTimeFormatByLanguage = () => {
        const translation = t("madera.timeFormat");
        //If we cannot get the value we set the default for each language
        if (translation === "madera.timeFormat") {
            return "hh:mm a";
        }
        return translation;
    };

    const formatDate = (date: Date, includeTime: boolean = false) => {
        const dateFormat = getDateFormatByLanguage();
        const timeFormat = getTimeFormatByLanguage();
        return moment(date).format(`${dateFormat} ${includeTime ? timeFormat : ""}`);
    };

    return { formatDate, getDateFormatByLanguage, getTimeFormatByLanguage };
};

export default useDateFormat;
